import dynamic from 'next/dynamic';

export default dynamic(() =>
	import(/* webpackChunkName:"GoogleMaps" */ './GoogleMapSection').then((mod) => mod.default)
);
